import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { map, mergeMap, tap } from 'rxjs';
import { FinancialService } from 'src/app/services/api/financial.service';
import { GeneralService, GlobalService, LocalStorageService } from 'src/app/services/index.service';
import { Location } from '@angular/common';
import { AreYouSureComponent } from 'src/app/shared/components/modals/are-you-sure/are-you-sure.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalDataService } from 'src/app/services/global/modal-data.service';

@Component({
  selector: 'app-entity-header-option',
  templateUrl: './entity-header-option.component.html',
  styleUrls: ['./entity-header-option.component.scss']
})
export class EntityHeaderOptionComponent implements OnInit {
  constructor(
    private router: Router,
    public general: GeneralService,
    private globalService: GlobalService,
    private storageService: LocalStorageService,
    private financialService: FinancialService,
    private location: Location,
    private dialog:MatDialog,
    private modalService:ModalDataService
  ) { }
  expandAccountClass = { 'max-h-[8.35rem]': false, 'mt-3': false }
  profileIsOpen: boolean = false
  profileClass = { 'opacity-0': true, 'hidden': true }
  isExpand: boolean = false;
  balancedValue = '0'
  mainImage = ''
  userImage = ''
  organImage = ''
  ngOnInit(): void {
    this.financialService.getBalancedValueObs().subscribe(
      (data: any) => {
        this.balancedValue = data
        let wallet = +this.general.convDegitToEnglish(data.toString().replaceAll(',', ''))
        wallet = +wallet.toString().substring(0, data.toString().length - 1)
        this.balancedValue = wallet.toLocaleString()
      }
    )
  }
  showProfile() {
    this.profileIsOpen = true
    this.profileClass = { 'opacity-0': true, 'hidden': false }
    setTimeout(() => { this.profileClass = { 'opacity-0': false, 'hidden': false } }, 100)
  }
  scrollToViewNavigate() {
    this.globalService.scrollToTopOfView('body')
  }
  hideProfile() {
    this.profileClass = { 'opacity-0': true, 'hidden': false }
    setTimeout(() => { this.profileClass = { 'opacity-0': true, 'hidden': true } }, 100)
    setTimeout(() => {
      this.profileIsOpen = false;
      this.isExpand = true;
      this.expandPanelAccount(); 
    }, 150)
  }
  changeProfileState() {
    this.profileIsOpen ? this.hideProfile() : this.showProfile()
  }
  skipChangeUrl(destination: string) {
    let basePath = destination.split('/')[0] == "" ? destination.split('/')[1] : destination.split('/')[0]
    this.globalService.scrollTop();
    this.router.navigateByUrl(`/${destination}/`, { skipLocationChange: true }).then(() =>
      this.router.navigate([destination])
    )
  }
  editPage(destination: string) {
    let account = this.globalService.jwtService.getCurrentAccountData()
    if(account){
      if(account.last_logined_role=='ORGAN'){
        return `${destination}/edit`
      }else{
        return `${destination}/edit/all`
      }
    }else{
      return '';
    }
  }
  logout() {
    if(!this.globalService.isDialogOpen()){
      const dialog = this.dialog.open(AreYouSureComponent, {
        id: 'app-are-you-sure' ,
        disableClose : true ,
        data:{
          parentId: '',
          action:'delete',
          message:'آیا مایل به خروج از حساب کاربری خود هستید؟',
          buttonText:'بله',
          negativeText:'خیر'
        }
      })
      dialog.componentInstance.selectOptionEmiiter.subscribe(
        (is_delete:any)=>{
          if(is_delete){
            dialog.close()
            this.modalService.is_sure = false
            this.router.navigate(['/auth/login'])
            this.profileIsOpen = false
            this.globalService.jwtService.logout()
          }
        }
      )
    }
  }
  accountUrl() {
    let user = this.account();
    if (user?.last_logined_role == 'USER') {
      return `/hamafarin/${user?.username}-${this.general.RegProfileUrl(user?.first_name)}-${this.general.RegProfileUrl(user?.last_name)}`
    }
    else {
      return `/organ/${user?.username}`
    }
  }
  profileUrl(role: any = null, account: any = null) {
    if (role){
      if (role == 'USER') {
        return `/hamafarin/${account?.username}-${this.general.RegProfileUrl(account?.first_name)}-${this.general.RegProfileUrl(account?.last_name)}`
      }
      else {
        return `/organ/${account?.username}`
      }
    } else {
      let user = this.globalService.jwtService.getCurrentAccountData();
      if (user?.last_logined_role == 'USER') {
        return `/hamafarin/${user?.username}-${this.general.RegProfileUrl(user?.first_name)}-${this.general.RegProfileUrl(user?.last_name)}`
      }
      else {
        return `/organ/${user?.username}`
      }
    }
  }
  checkAccountIsOrgan(){
    return this.globalService.checkUserIsOrganObs()
  }
  expandPanelAccount() {
    this.isExpand = !this.isExpand;
    if (this.isExpand) {
      this.expandAccountClass = { 'max-h-[8.35rem]': true, 'mt-3': true }
    } else {
      this.expandAccountClass = { 'max-h-[8.35rem]': false, 'mt-3': false }
    }
  }
  switchAccount(username: string, role: string, organ: any = null) {
    let refreshToken = this.globalService.jwtService.getRefreshToken()
    this.globalService.jwtService.changeRole(refreshToken, role == 'ORGAN' ? username : null).pipe(
      (
        mergeMap((response: any) => {
          this.globalService.jwtService.distributionToken(response);
          return this.getBalancedWalletObs().pipe(
            map(() => response)
          )
        })
      )
    ).subscribe(
      (token) => {
        let convertData: any = Object.assign({}, this.user());
        convertData.username = role == 'USER' ? convertData.username : this.globalService.jwtService.getCurrentAccountData().username
        this.globalService.scrollTop()
        this.location.replaceState(`${this.profileUrl(role, role == 'USER' ? convertData : organ)}`);
        sessionStorage.setItem('temp_identity', JSON.stringify({ role: role, username: username }));
        window.location.reload();
      },
      (error) => {
        // console.log(error)
      }
    )
  }
  getBalancedWalletObs() {
    return this.financialService.getWallet().pipe(
      tap((response: any) => {
        let x = +this.general.convDegitToEnglish(response.balance.toString().replaceAll(',', ''))
        x = +x.toString().substring(0, response.balance.toString().length - 1)
        this.balancedValue = x.toLocaleString()
        this.financialService.setBalancedValue(this.balancedValue)
      })
    )
  }
  checkFemaleGender() {
    return this.globalService.returnGender(this.globalService.jwtService.getCurrentAccountDataObs()) == 'FEMALE'
  }
  checkDarkMode() {
    return this.globalService.checkDarkMode()
  }
  isOrganObs() {
    return this.globalService.checkUserIsOrganObs()
  }
  checkRoleIsPerson(){
    return this.globalService.jwtService.checkRoleIsPerson()
  }
  handleImageDefualt(entityType: 'organ'|'hamafarin'|'quiz'|'magazine'|string | undefined, gender = ''){
    return this.globalService.handleImageDefualt(entityType, gender)
  }
  removeWalletStorage(){
    this.storageService.removeItem('pay')
  }
  user(){
    return this.globalService.jwtService.getCurrentUserData()
  }
  account(){
    return this.globalService.jwtService.getCurrentAccountData()
  }
  organs(){
    return this.globalService.jwtService.getOrgans()
  }
  getMainImage() {
    this.globalService.handleImageDefualt(this.globalService.jwtService.getCurrentAccountData()?.entity, this.globalService.jwtService.getCurrentAccountData()?.gender)
      .subscribe((image: any) => {
        this.mainImage = image
      })
  }
  getUserImage() {
    this.globalService.handleImageDefualt('hamafarin', this.globalService.jwtService.getCurrentUserData()?.gender)
      .subscribe((image) => {
        this.userImage = image;
      })
  }
  getOrganImage() {
    this.globalService.handleImageDefualt('organ')
      .subscribe((image) => {
        this.organImage = image
      })
    setTimeout(() => {

    }, 2000);
  }
  loadImage(imgLabel:string){
    return this.globalService.loadImage(imgLabel)
  }
  imageObject(imgLabel:string){
    return this.globalService.imgObject[imgLabel]
  }
  storageToken(){
    return this.globalService.jwtService.storage.getItem('token')
  }
  getClassStyleHeader(){
    let classList = ''
    classList += this.account()?.last_logined_role=='USER'?' rounded-full':' rounded-[5px]'
    classList += this.account()? ' focus:border-2 focus:border-lightMode-500':''
  return classList
  }
}